import { render, staticRenderFns } from "./AddNewAgentDeposit.vue?vue&type=template&id=3f36f988&scoped=true&"
import script from "./AddNewAgentDeposit.vue?vue&type=script&lang=js&"
export * from "./AddNewAgentDeposit.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAgentDeposit.vue?vue&type=style&index=0&id=3f36f988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36f988",
  null
  
)

export default component.exports